import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { NavBarApi, NavBarApiImpl } from './apis';

export const navBarModule = new ContainerModule(bind => {
    bind(NavBarApi).to(NavBarApiImpl);
});
